var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "#E0482D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29214 8.12096C7.96594 7.98084 7.82731 7.57286 8.02303 7.27614C8.41854 6.68271 9.07909 6.25 9.95166 6.25C10.9099 6.25 11.5663 6.69095 11.9007 7.24317C12.1861 7.71709 12.3533 8.60312 11.9129 9.26249C11.4236 9.99192 10.9547 10.2145 10.7019 10.6843C10.6407 10.7955 10.6041 10.8862 10.5796 11.0716C10.5429 11.3725 10.2982 11.6074 9.99651 11.6074C9.64177 11.6074 9.35227 11.2983 9.39305 10.9398C9.41751 10.7296 9.46644 10.5112 9.58061 10.3051C9.89458 9.73229 10.498 9.39436 10.8487 8.88747C11.2197 8.35586 11.0118 7.36268 9.95981 7.36268C9.48275 7.36268 9.17287 7.61407 8.98123 7.91491C8.83852 8.14981 8.54086 8.22398 8.29214 8.12096ZM10.7712 13.2558C10.7712 13.7091 10.4043 14.08 9.95574 14.08C9.50722 14.08 9.14025 13.7091 9.14025 13.2558C9.14025 12.8025 9.50722 12.4316 9.95574 12.4316C10.4043 12.4316 10.7712 12.8025 10.7712 13.2558Z",
    fill: "#E0482D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleQuestion);
export default __webpack_public_path__ + "static/media/circle-question.74a0df07a9650310386e193caeb38a30.svg";
export { ForwardRef as ReactComponent };